import { managedKnowledgeListItemSchema } from "@redotech/shopper-agent-knowledge-common/managed-knowledge-view";
import { merchantKnowledgeSuggestionViewSchema } from "@redotech/shopper-agent-knowledge-common/suggested-merchant-knowledge-view";
import * as z from "zod";

export const listKnowledge = {
  name: "listKnowledge" as const,
  input: z.object({
    /** Present switches to index-backed search; absent browses the table. */
    query: z.string().optional(),
    limit: z.number().int().positive().optional(),
    offset: z.number().int().nonnegative().optional(),
    maxSuggestions: z.number().int().nonnegative().optional(),
  }),
  output: z.object({
    /** Every corpus in one paged order, tagged by `type` — FAQ is read-only. */
    items: z.array(managedKnowledgeListItemSchema),
    /** Pending proposals only, capped, shown above the items. */
    suggestions: z.array(merchantKnowledgeSuggestionViewSchema),
    /** Items matching, for the pager. Suggestions are not paged. */
    totalItemCount: z.number(),
  }),
};
